import { Component, input } from '@angular/core';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [],
  template: `
    <div [class]="'bg-card shadow-md ' + innerClass()">
      <ng-content></ng-content>
    </div>
  `,
  styles: ``
})
export class CardComponent {
  innerClass = input<string | undefined>('');
}
